import * as PropTypes from 'prop-types'

import stackedSliderStyles from './StackedSlider.css'

import { TextCopy } from '/react/library/'

export class StackedSliderIndicator extends React.PureComponent {
  static propTypes = {
    activeSlideIndex: PropTypes.number.isRequired,
    originalTotalSlides: PropTypes.number.isRequired
  }

  getCurrentSlideNumber = (activeSlideIndex, originalTotalSlides) => {
    let currentSlideNumber = activeSlideIndex + 1

    if (currentSlideNumber > originalTotalSlides) {
      currentSlideNumber = (activeSlideIndex % originalTotalSlides) + 1
    }

    return currentSlideNumber
  }

  render () {
    const {
      activeSlideIndex,
      originalTotalSlides
    } = this.props

    return (
      <div className={stackedSliderStyles.indicator}>
        <TextCopy isLight isTight>
          {this.getCurrentSlideNumber(activeSlideIndex, originalTotalSlides)}
        </TextCopy>
        <span className={stackedSliderStyles.indicatorSeperator} />
        <TextCopy isLight isTight>
          {originalTotalSlides}
        </TextCopy>
      </div>
    )
  }
}
